<template>
  <b-row>
    <b-col>
      <b-card>
        <h5>{{ $t('views.technicians.show.dispatcher.header') }}</h5>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'TechnicianForDispatcher',
  computed: mapGetters({
    deleteError: 'userdata/del/error',
    error: 'userdata/show/error',
    isLoading: 'userdata/show/isLoading',
    item: 'userdata/show/retrieved'
  }),

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      del: 'userdata/del/del',
      reset: 'userdata/show/reset',
      retrieve: 'userdata/show/retrieve'
    }),

    deleteItem (item) {
      if (window.confirm('Are you sure you want to delete this item?')) {
        this.del(item).then(() => this.$router.push({ name: 'UserDataList' }))
      }
    }
  }
}
</script>
